module.exports = __webpack_public_path__ + "static/media/logo-vinarborg.ee47aa55.png";